import { render, staticRenderFns } from "./AppPoweredBy.vue?vue&type=template&id=7cff5017"
import script from "./AppPoweredBy.vue?vue&type=script&lang=js"
export * from "./AppPoweredBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports